"use client";

import { useState } from "react";
import Modal from "..";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import { ArrowDownLoad } from "@/components/icons";
import { useSession } from "next-auth/react";
import { toast } from "sonner";

const DownloadCertificate = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { data: session }: any = useSession();

  // Download certificate
  const handleCertificate = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_ADMIN_PANEL_BASE_URL}/certificate/${session?.user?.certificate_key}`
      );

      if (!res.ok) throw new Error("Failed to fetch certificate.");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "certificate.pdf";
      document.body.appendChild(link);
      link.click();

      // cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setOpen(false);
      toast.success("Certificate downloaded successfully");
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="secondary"
        onClick={() => setOpen(true)}
        className="w-full lg:w-fit"
      >
        <ArrowDownLoad className="size-5 text-white" />
        Download Certificate
      </Button>
      <Modal
        open={open}
        onOpenChange={() => setOpen(false)}
        classes={{ dialogContent: "sm:max-w-[604px]" }}
      >
        <div className="flex flex-col">
          <Image
            src={"/assets/course/download-certificate.svg"}
            alt="success"
            width={1000}
            height={700}
            className="mx-auto mb-6 h-auto w-full max-w-60 object-contain object-center"
            priority
          />
          <h3 className="text-primary mb-2 text-center text-3xl font-semibold">
            Are You Sure You Want to Download the Certificate?
          </h3>
          <p className="text-center text-base font-normal text-slate-600">
            Once downloaded, the certificate cannot be changed. Please
            double-check your name and other details before proceeding.
          </p>
          <div className="mt-10 flex w-full justify-between gap-4">
            <Button
              type="button"
              variant="outline"
              className="w-1/2 rounded-full"
              onClick={() => setOpen(false)}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              onClick={handleCertificate}
              type="button"
              className="w-1/2 rounded-full"
              variant="secondary"
              disabled={loading}
            >
              {loading && (
                <span className="size-4 animate-spin rounded-full border-t-2 border-b-2 border-white"></span>
              )}
              {loading ? "Downloading..." : "Download"}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DownloadCertificate;
